import {slideRight, slideWidthFromTo} from "../helpers";

class SearchBarSingle {
	constructor(el) {
		this.el  = el
		this.btn = this.el.querySelector( ':scope > .search-bar__btn' )

		this.el.addEventListener(
			'click',
			(e) => {
            e.stopPropagation()
				if ( ! this.el.classList.contains( 'is-active' )) {
					e.preventDefault()
					this.el.classList.add( 'is-active' )
					slideRight( this.el )
				}
			}
		)

		document.addEventListener(
			'click',
			() => {
            if (this.el.classList.contains( 'is-active' )) {
                this.el.classList.remove( 'is-active' )
                slideWidthFromTo( this.el, this.el.offsetWidth, this.btn.offsetWidth, null, false )
            }
			}
		)
	}
}

export default class SearchBar {
	constructor() {
		Array.from( document.querySelectorAll( '.search-bar' ) ).forEach( el => new SearchBarSingle( el ) )
	}
}
